export default __webpack_public_path__ + "static/media/logo_edot_nabati.86c5b886.jpg";